import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export const AddReportIssue = async (
  reportcontent: string,
  subject: string,
  token: string
) => {
  const baseUrl = getApiBaseUrl();
  const apiUrl = `${baseUrl}/api/ReportIssue/AddReportIssue`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        reportcontent,
        subject,
      }),
    });

    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.message || "Failed to submit report issue");
    }

    return data;
  } catch (error: any) {
    throw new Error(error.message || "Something went wrong");
  }
};